import { Outlet } from "react-router-dom";

const PropertyRoot = () => {
  return (
    <div className="p-2">
      <Outlet />
    </div>
  );
};

export default PropertyRoot;
